import React, { ComponentType, LazyExoticComponent } from "react";

const Home = React.lazy(() => import("./Pages/Home/home"));
const Edit = React.lazy(() => import("./Pages/Edit/edit"));
const Landing = React.lazy(() => import("./Pages/Landing/landing"));
const Features = React.lazy(() => import("./Pages/Features/Features"));
const FAQ = React.lazy(() => import("./Pages/FAQ/faq"));
const Pricing = React.lazy(() => import("./Pages/Pricing/pricing"));
const TermsCondition = React.lazy(() => import("./Pages/TermsCondition/termsCondtions"));
const ShareImage = React.lazy(() => import("./Components/shareImage/ShareImage"));
const AddTemplate = React.lazy(() => import("./Pages/AddTemplate/AddTemplate"));
const BlogDetails = React.lazy(() => import("./Pages/BlogDetails/blogDetails"));
const Blogs = React.lazy(() => import("./Pages/Blogs/blogs"));
const RefundPolicy = React.lazy(() => import("./Pages/RefundPolicy/refundPolicy"));
const PrivacyPolicy = React.lazy(() => import("./Pages/PrivacyPolicy/privacyPolicy"));

export interface RouteConfig {
  path: string;
  component: ComponentType<any> | LazyExoticComponent<ComponentType<any>>;
  exact?: boolean;
}

export const routes: RouteConfig[] = [
  { path: "/", component: Landing, exact: true },
  { path: "/features", component: Features },
  { path: "/pricing", component: Pricing },
  { path: "/faq", component: FAQ },
  { path: "/terms", component: TermsCondition },
  { path: "/refund-policy", component: RefundPolicy },
  { path: "/privacy-policy", component: PrivacyPolicy },
  { path: "/home", component: Home },
  { path: "/addtemplate", component: AddTemplate },
  { path: "/edit", component: Edit },
  { path: "/shareimage", component: ShareImage },
  { path: "/blogs", component: Blogs },
  { path: "/blogs/:slug", component: BlogDetails },
];
